import React from 'react';
import { useNuPlayerContext } from '../NuPlayerContext';

export const TrackInfo = () => {
  const { currentTrack } = useNuPlayerContext();

  return (
    <div className="npTrackInfo">
        <img src={currentTrack.thumbnail} alt={currentTrack.title} />
    </div>
  );
};
